import type { Course } from "../../shared/types.js";
import { getLibraryCourse } from "./http.js";
import { getCourseCache, setCourseCache } from "./storage.js";

const memoryCache = new Map<string, Course>();

/** Course data is permanent library content; cache it client-side too so scorecards
 * and the leaderboard keep working offline once a round's course has been loaded once. */
export async function loadCourse(courseId: string): Promise<Course | null> {
  const cached = memoryCache.get(courseId) ?? getCourseCache(courseId);
  if (cached) {
    memoryCache.set(courseId, cached);
    if (navigator.onLine === false) return cached;
  }

  try {
    const course = await getLibraryCourse(courseId);
    memoryCache.set(courseId, course);
    setCourseCache(course);
    return course;
  } catch {
    return cached ?? null;
  }
}
